import { ApiClient } from '@/shared/api-client';
import { friendlyDistance, friendlyDistanceStrict} from '@/shared/filters';
import { differenceInSeconds } from 'date-fns';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

interface IImpersonationBarProps {
    impersonationExpiry: string;
    translations: { [key: string]: string; };
    twoLetterCulture: string;
}

@Component({
    filters: {
        friendlyDistance,
        friendlyDistanceStrict
    }
})
export default class ImpersonationBarComponent extends Vue {

    @Prop() public properties!: IImpersonationBarProps;

    public expiry: Date = new Date(this.properties.impersonationExpiry);

    public now: Date = new Date();

    private timer: any = null;

    private apiClient: ApiClient = new ApiClient();

    private isPerformingAction: boolean = false;

    /**
     * Life cycle hook for when component is created
     */
    public /* override */ created() {

        this.startTimer();
    }

    public async end(): Promise<void> {

        if (this.isPerformingAction) {

            return;
        }

        this.isPerformingAction = true;

        try {

            await this.apiClient.impersonation.end();

            window.location.href = '/shell';

        } catch {

            this.isPerformingAction = false;

            alert(this.properties.translations[`impersonation_bar_end_error_message`]);
        }
    }

    private startTimer() {

        this.timer = setInterval(() => {

            // Forcing update so time updates through friendlyDistanceStrict-filter every second :)

            const diff = differenceInSeconds(this.expiry, new Date());

            if (diff <= 0) {

                clearInterval(this.timer);

                window.location.reload();

                return;
            }

            this.$forceUpdate();

        }, 1000);
    }
}
